import { ErrorHandler } from '../types/error.types';

let globalErrorHandler: ErrorHandler | null = null;

export const setGlobalErrorHandler = (handler: ErrorHandler) => {
  globalErrorHandler = handler;
};

export const getGlobalErrorHandler = () => globalErrorHandler;
